import { action, computed, makeObservable, observable } from 'mobx';

export default class ModalDelegate {
  private _isVisible = false;
  private _isLoading = false;

  get isVisible(): boolean {
    return this._isVisible;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  public setIsLoading(status: boolean): void {
    this._isLoading = status;
  }

  open(): void {
    this._isVisible = true;
  }

  close(): void {
    this._isVisible = false;
  }

  constructor(initialState = false) {
    this._isVisible = initialState;
    makeObservable<ModalDelegate, '_isVisible' | '_isLoading'>(this, {
      _isVisible: observable,
      _isLoading: observable,
      isVisible: computed,
      isLoading: computed,
      setIsLoading: action.bound,
      open: action.bound,
      close: action.bound,
    });
  }
}
